import React from "react";

import { type OtherInfoItem, OtherInfoItemTypeEnum } from "../../map-panel-context";

import { SectionBadges } from "./section-badges";
import { SectionBasicInfoList } from "./section-basic-info-list";
import { SectionTitle } from "./section-title";

interface OtherInfoProps {
  items: OtherInfoItem[];
}

export const OtherInfo: React.FC<OtherInfoProps> = ({ items }) => {
  const badges = items.filter((item) => item.type === OtherInfoItemTypeEnum.badge);
  const keyValueItems = items.filter((item) => item.type === OtherInfoItemTypeEnum.keyValue);

  return (
    <div>
      <SectionTitle title="Other Info" />
      {keyValueItems.length > 0 && (
        <SectionBasicInfoList
          items={keyValueItems.map((item) => ({
            type: "badge" as const,
            head: item.label,
            value: item.value ?? "--",
            valueClassName: "capitalize",
          }))}
        />
      )}

      <SectionBadges items={badges.length > 0 ? badges.map((b) => b.label) : ["--"]} />
    </div>
  );
};
